/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, NumberInput, Textarea, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import React, { useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { BsArrowRightSquare, BsArrowsMove } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import OnlyFooter from "../components/common_components/OnlyFooter";
import Navbar from "../components/layout_components/Navbar";
import Halment from "../faetures/Halment";
import contact from "../images/featured/contact-img.png";
import { addMessage } from "../redux/actions/frontendActions/messageAction";
function Contact() {
  const dispatch = useDispatch();
  const { myInfo } = useSelector((state) => state.Auth);
  const { loader, messageSuccessMessage, messageErrorMessage } = useSelector(
    (state) => state.Message
  );
  const form = useForm({
    initialValues: {
      firstName: myInfo.firstName,
      lastName: myInfo.lastName,
      phone: myInfo.phone,
      email: myInfo.email,
      message: "",
      status: myInfo.status,
      image: myInfo.image,
    },

    validate: {
      firstName: (value) =>
        value.length < 2 ? "First Name rquired  with 2 caracter " : null,
      lastName: (value) =>
        value.length < 2 ? "Last Name required with 2 caracter" : null,
      phone: (value) =>
        value.length < 11 ? "Phone number would be 11 digits" : null,

      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
      message: (value) => (value.length < 1 ? "Write something.." : null),
    },
  });
  const handleMessageSubmit = () => {
    dispatch(addMessage(form.values));
  };
  useEffect(() => {
    if (messageSuccessMessage) {
      toast.success(messageSuccessMessage);
      window.location.reload();
    }
  }, [messageSuccessMessage, messageErrorMessage]);

  return (
    <>
      <Halment title="Contact" />
      <Navbar />
      <Toaster
        position={"bottom-center"}
        reverseOrder={false}
        toastOptions={{
          style: {
            fontSize: "15px",
          },
        }}
      />
      <div className="contact_area_wrapper">
        <div className="margin_container">
          <div className="contact_item_would_be_grid">
            <div className="left">
              <div className="form_wrapper">
                <div className="form_top">
                  <h1>Get in Toutch</h1>
                  <p>
                    Feel free to get in touch with me. I am always open to
                    discussing new projects, creative ideas or challenges
                    opportunities.
                  </p>
                </div>
              </div>

              <form onSubmit={form.onSubmit(handleMessageSubmit)}>
                <div className="form_item form_flex">
                  <div className="form_flex_item">
                    <TextInput
                      required
                      withAsterisk
                      label="First Name"
                      placeholder="Jhon"
                    />
                  </div>
                  <div className="form_flex_item">
                    <TextInput
                      required
                      withAsterisk
                      label="Last Name"
                      placeholder="Doe"
                    />
                  </div>
                </div>
                <div className="form_item">
                  <NumberInput
                    required
                    withAsterisk
                    label="Phone"
                    placeholder="Phone"
                  />
                </div>
                <div className="form_item">
                  <TextInput
                    required
                    withAsterisk
                    label="Email Address"
                    placeholder="your@email.com"
                  />
                </div>
                <div className="form_item">
                  <Textarea
                    required
                    placeholder="Your comment"
                    label="Your comment"
                    withAsterisk
                  />
                </div>
                <div className="form_item">
                  <div className="submit_button">
                    <Button type="submit" variant="filled">
                      {loader ? "Plesae Wait!" : "Send Message"}{" "}
                      <BsArrowRightSquare />
                    </Button>
                  </div>
                </div>
              </form>

              <div className="address_area">
                <ul>
                  <li>
                    {" "}
                    <BsArrowsMove />{" "}
                    <a href="mailto:iasraful107@gmail">iasraful107@gmail</a>
                  </li>
                  <li>
                    {" "}
                    <BsArrowsMove />{" "}
                    <a href="tel:01758015756">+880 1758- 015756</a>
                  </li>
                  <li>
                    {" "}
                    <BsArrowsMove /> <a href="#">Gazipur, Dhaka , Bangladesh</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="right">
              <div className="img_area">
                <img src={contact} alt="Contact Image. Loading..." />
              </div>
            </div>
          </div>
        </div>
      </div>

      <OnlyFooter />
    </>
  );
}

export default Contact;
